export default __webpack_public_path__ + "static/media/bank-active.dc8f4aa8.svg";